/* Native cart drawer — phase 1 shell.
   Open/close, fetch cart, render line items, quantity, remove, subtotal, checkout.
   Reward bar, subscriptions, recommendations, and promo apply come in later phases.
   No store-level behavior here. */
(function () {
  "use strict";

  var root = document.getElementById("NativeCart");
  if (!root) return;

  var itemsEl = root.querySelector("[data-ncart-items]");
  var subtotalEl = root.querySelector("[data-ncart-subtotal]");
  var checkoutBtn = root.querySelector("[data-ncart-checkout]");
  var shopPayBtn = root.querySelector("[data-ncart-shoppay]");

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* ---- currency conversion ----
     Thresholds are stored in the shop currency (USD). Shopify shows Canadian shoppers
     CAD prices and cart.js totals come back in CAD, so a $50 threshold would otherwise
     unlock at CA$50 (about US$36). Shopify.currency.rate is the shop-to-presentment
     rate for the current session (1 when the shopper is in USD). Gift tiers are always
     converted so the gift unlocks at a true US$50; the free-shipping tier is converted
     only when "fxShipping" is on, because the Canada shipping rate itself is a fixed
     CAD amount and the bar should match what checkout really charges. */
  function fxRate() {
    try {
      var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      return r > 0 ? r : 1;
    } catch (e) { return 1; }
  }
  function fxCurrency() {
    try { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ""; } catch (e) { return ""; }
  }
  function fxApplies(t) {
    return t.type === "gift" || (t.type === "shipping" && !!config.fxShipping);
  }
  /* Stamp the rate on the cart (once per page load) so the checkout extension, which
     has no access to exchange rates, can convert the same way. Only when converting. */
  var rateStamped = false;
  function stampRate(cart) {
    if (rateStamped) return;
    var rate = fxRate();
    var have = cart && cart.attributes && cart.attributes._ncart_rate;
    rateStamped = true;
    var want = rate === 1 ? "" : String(rate); /* back in the shop currency: clear the stamp */
    if (String(have || "") === want) return;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ attributes: { _ncart_rate: want, _ncart_currency: want ? fxCurrency() : "" } }),
    }).catch(function () {});
  }

  /* Request a small rendition of a Shopify CDN image instead of the full-size original
     (thumbnails were loading 2000-3000px files). */
  function thumb(src, w) {
    if (!src) return "";
    src = String(src);
    if (src.indexOf("cdn.shopify.com") === -1) return src;
    if (/[?&]width=/.test(src)) return src;
    return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=" + (w || 240);
  }

  /* Persona offers: the cart attribute _offer (set by the persona/quiz flows) can carry
     "Free Shipping". A store-level Shopify Function honors it at checkout, so the reward
     bar shows the free-shipping tier as unlocked. Mirrors cust-persona-rebuy-freeship.js,
     which did this for the Rebuy bar. */
  function personaFreeShipping(cart) {
    var raw = cart && cart.attributes && (cart.attributes._offer || cart.attributes["_offer"]);
    if (!raw) return false;
    var txt = String(raw);
    try { var j = JSON.parse(raw); if (Array.isArray(j)) txt = j.join(","); } catch (e) {}
    return txt.indexOf("Free Shipping") !== -1;
  }

  /* reward-tier config emitted by the section */
  var config = { showRewards: false, tiers: [] };
  try {
    var cfgEl = root.querySelector("[data-ncart-config]");
    if (cfgEl) config = JSON.parse(cfgEl.textContent);
  } catch (e) {}

  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h13v13H1z"/><path d="M14 8h4l3 3v5h-7z"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7S11 2 8 2 5 5 5 5s1 2 3 2h4z"/><path d="M12 7s1-5 4-5 3 3 3 3-1 2-3 2h-4z"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3 6.5 7 .8-5 4.7 1.3 6.9L12 17.8 5.4 20.9 6.7 14 1.7 9.3l7-.8z"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12l-8 8-9-9V3h8z"/><circle cx="7" cy="7" r="1.4"/></svg>',
    crown: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18h18l-1-9-5 4-4-7-4 7-5-4z"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-4.5-9.5-9C1 9 2.5 5.5 6 5.5c2 0 3 1.2 6 4 3-2.8 4-4 6-4 3.5 0 5 3.5 3.5 6.5C19 16.5 12 21 12 21z"/></svg>',
  };

  function countryAllowed() {
    if (!config.countries) return true;
    var list = String(config.countries).split(",").map(function (s) { return s.trim().toUpperCase(); });
    return list.indexOf(String(config.currentCountry || "").toUpperCase()) !== -1;
  }

  function renderRewards(cart) {
    var box = root.querySelector("[data-ncart-rewards]");
    if (!box) return;
    var freeShipOffer = personaFreeShipping(cart);
    var tiers = effectiveTiers()
      .filter(function (t) { return t.threshold > 0; })
      .map(function (t) {
        var c = {}; for (var k in t) c[k] = t[k];
        if (freeShipOffer && c.type === "shipping") c.threshold = 0; /* already earned via _offer */
        return c;
      })
      .sort(function (a, b) { return a.threshold - b.threshold; });

    if (!config.showRewards || tiers.length === 0 || !countryAllowed()) {
      box.hidden = true;
      return;
    }
    box.hidden = false;

    var total = qualifyingTotal(cart);
    var n = tiers.length;

    /* equal segments: each reward occupies 1/n of the bar; the fill reaches a
       reward's dot exactly when that reward unlocks (Option B). */
    var metCount = 0;
    tiers.forEach(function (t) { if (total >= t.threshold) metCount++; });
    var fill;
    if (metCount >= n) {
      fill = 100;
    } else {
      var k = metCount;
      var prev = k === 0 ? 0 : tiers[k - 1].threshold;
      var span = tiers[k].threshold - prev;
      var frac = span > 0 ? (total - prev) / span : 0;
      frac = Math.max(0, Math.min(1, frac));
      fill = ((k + frac) / n) * 100;
    }

    /* icons + labels stay evenly spaced (unchanged positions) */
    var tiersHtml = tiers
      .map(function (t) {
        var met = total >= t.threshold;
        return (
          '<div class="ncart__tier' + (met ? " is-met" : "") + '">' +
          (ICONS[t.icon] || ICONS.star) +
          "<span>" + t.label + "</span></div>"
        );
      })
      .join("");

    /* dots sit on the bar at each reward's unlock point */
    var dotsHtml = tiers
      .map(function (t, idx) {
        var met = total >= t.threshold;
        var pos = ((idx + 1) / n) * 100;
        return '<div class="ncart__dot' + (met ? " is-met" : "") + '" style="left:' + pos + '%"></div>';
      })
      .join("");

    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (total < tiers[i].threshold) { next = tiers[i]; break; }
    }
    var msg;
    if (giftNotice) {
      msg = giftNotice;
    } else if (!next) {
      msg = "You've unlocked every reward!";
    } else {
      var away = money(next.threshold - total);
      msg =
        next.type === "shipping"
          ? "You're only <strong>" + away + "</strong> away from <strong>FREE shipping</strong>"
          : "Add <strong>" + away + "</strong> to unlock <strong>" + next.label + "</strong>";
    }

    box.innerHTML =
      '<div class="ncart__tiers">' + tiersHtml + "</div>" +
      '<div class="ncart__bar-wrap"><div class="ncart__bar"><span style="width:' + fill + '%"></span></div><div class="ncart__dots">' + dotsHtml + "</div></div>" +
      '<div class="ncart__msg">' + msg + "</div>";
  }

  function open() {
    root.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    refresh();
  }
  function close() {
    root.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  /* ---- real free-gift line management ----
     Adds the configured gift product as a real cart line (tagged _ncart_gift) once
     the qualifying subtotal (everything except gifts) reaches a gift tier's
     threshold, and removes it when the cart drops back below. A discount (native
     Buy X Get Y, or our Shopify Function) then makes that line $0. */
  function isGiftLine(it) {
    return !!(it.properties && (it.properties._ncart_gift === "true" || it.properties._ncart_gift === true));
  }
  function qualifyingTotal(cart) {
    /* Post-discount total of everything except the gift. We start from
       cart.total_price (which already reflects order/code discounts) and subtract
       the gift lines, so a promo code that drops the order below the threshold
       correctly un-qualifies the gift. */
    var giftSum = (cart.items || []).reduce(function (sum, it) {
      return isGiftLine(it) ? sum + it.final_line_price : sum;
    }, 0);
    return Math.max(0, (cart.total_price || 0) - giftSum);
  }
  /* ---- scheduled gift swap ----
     After a gift tier's switchAt (epoch seconds, set on the tier block), its "next" product/label take over. */
  function swapActive(t) {
    var at = Number(t.switchAt || 0);
    return at > 0 && Date.now() / 1000 >= at;
  }
  function effectiveTiers() {
    var rate = fxRate();
    return (config.tiers || []).map(function (t) {
      var c = {}; for (var k in t) c[k] = t[k];
      if (t.type === "gift" && t.nextGiftVariant && swapActive(t)) {
        c.giftVariant = t.nextGiftVariant;
        c.giftTitle = t.nextGiftTitle || t.giftTitle;
        c.giftImage = t.nextGiftImage || t.giftImage;
        c.giftPrice = t.nextGiftPrice || t.giftPrice;
        if (t.nextLabel) c.label = t.nextLabel;
      }
      /* threshold (USD cents) -> presentment cents, so it compares to cart.js totals */
      if (rate !== 1 && fxApplies(t)) c.threshold = Math.round(t.threshold * rate);
      return c;
    });
  }
  /* re-render at the exact switch moment if the page is open across it */
  (config.tiers || []).forEach(function (t) {
    var at = Number(t.switchAt || 0);
    if (!at) return;
    var ms = at * 1000 - Date.now();
    if (ms <= 0 || ms > 2147000000) return;
    setTimeout(function () {
      if (root.getAttribute("aria-hidden") === "false") refresh();
    }, ms + 500);
  });

  function giftTiers() {
    return effectiveTiers().filter(function (t) {
      return t.type === "gift" && t.threshold > 0 && t.giftVariant;
    });
  }
  var reconciling = false;
  /* Which promo code (if any) is on the cart right now. */
  function appliedCode(cart) {
    var dc = (cart.discount_codes || []).filter(function (d) { return d.applicable !== false; })[0];
    if (dc) return String(dc.code || "").toUpperCase();
    var app = (cart.cart_level_discount_applications || []).filter(function (a) { return a.type === "discount_code"; })[0];
    return app ? String(app.title || "").toUpperCase() : "";
  }
  /* Codes that can't be combined with the free gift (Shopify keeps the code and charges the
     gift). Remembered for the session so we don't add/remove the gift on every refresh. */
  function giftBlockedBy(code) {
    try { return !!code && (sessionStorage.getItem("ncart_gift_blocked") || "") === code; } catch (e) { return false; }
  }
  function markGiftBlocked(code) {
    try { sessionStorage.setItem("ncart_gift_blocked", code); } catch (e) {}
  }
  var giftNotice = "";
  function reconcileGifts(cart) {
    if (reconciling) return Promise.resolve(cart);
    var qualifying = qualifyingTotal(cart);
    var allowed = config.showRewards && countryAllowed();
    var existing = (cart.items || []).filter(isGiftLine);
    var code = appliedCode(cart);

    /* A gift line that is NOT free (final price > 0) means a non-combinable code won —
       but only if the cart still qualifies. Below the threshold the gift is not free
       because of the total, not the code, and must not mark the code as blocked
       (otherwise the gift never comes back for the rest of the session). */
    /* per tier: a gift line is suspicious only if its OWN tier is still earned */
    var tierOf = {};
    giftTiers().forEach(function (t) { tierOf[String(t.giftVariant)] = t; });
    var notFree = existing.filter(function (it) {
      var t = tierOf[String(it.variant_id)];
      return (it.final_line_price || 0) > 0 && t && qualifying >= t.threshold;
    });
    if (code && notFree.length) markGiftBlocked(code);
    var blocked = giftBlockedBy(code);
    giftNotice = blocked ? "Your code can't be combined with the free gift, so the gift was removed." : "";

    var wanted = [];
    giftTiers().forEach(function (t) {
      if (allowed && !blocked && qualifying >= t.threshold) wanted.push(String(t.giftVariant));
    });

    var ops = [];
    wanted.forEach(function (v) {
      if (!existing.some(function (it) { return String(it.variant_id) === v; })) ops.push({ add: v });
    });
    existing.forEach(function (it) {
      var keep = wanted.indexOf(String(it.variant_id)) !== -1 && (it.final_line_price || 0) === 0;
      if (!keep && wanted.indexOf(String(it.variant_id)) !== -1 && it.quantity > 1) { ops.push({ qty1: it.key }); return; }
      if (!keep) ops.push({ remove: it.key });
    });
    if (!ops.length) return Promise.resolve(cart);

    reconciling = true;
    if (checkoutBtn) checkoutBtn.disabled = true;
    if (shopPayBtn) shopPayBtn.disabled = true;
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () {
        if (op.add) {
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: Number(op.add), quantity: 1, properties: { _ncart_gift: "true" } }),
          });
        }
        return fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: op.qty1 || op.remove, quantity: op.qty1 ? 1 : 0 }),
        });
      });
    });
    return chain
      .then(function () { return getCart(); })
      .catch(function () { return cart; })
      .finally(function () {
        reconciling = false;
        if (checkoutBtn) checkoutBtn.disabled = false;
        if (shopPayBtn) shopPayBtn.disabled = false;
      });
  }

  /* ---- subscription plans (Recharge selling plans), read per product ---- */
  var planCache = {};
  function getPlans(handle) {
    if (!handle) return Promise.resolve({ plans: [], requires: false });
    if (planCache[handle]) return Promise.resolve(planCache[handle]);
    return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var plans = [];
        (p.selling_plan_groups || []).forEach(function (g) {
          (g.selling_plans || []).forEach(function (sp) {
            var pct = 0;
            var adj = sp.price_adjustments && sp.price_adjustments[0];
            if (adj && adj.value_type === "percentage") pct = adj.value;
            plans.push({ id: sp.id, name: sp.name, pct: pct });
          });
        });
        planCache[handle] = { plans: plans, requires: !!p.requires_selling_plan };
        return planCache[handle];
      })
      .catch(function () { planCache[handle] = { plans: [], requires: false }; return planCache[handle]; });
  }
  function pickDefaultPlan(plans) {
    if (!plans.length) return null;
    for (var i = 0; i < plans.length; i++) { if (/60|2\s*month/i.test(plans[i].name)) return plans[i].id; }
    return (plans[Math.min(1, plans.length - 1)] || plans[0]).id;
  }
  function renderWithPlans(cart) {
    var handles = [];
    (cart.items || []).forEach(function (it) { if (it.handle && handles.indexOf(it.handle) === -1) handles.push(it.handle); });
    return Promise.all(handles.map(getPlans)).then(function () { render(cart); });
  }

  function changePlan(key, sellingPlan) {
    /* /cart/change.js resets quantity to 1 unless it's sent, so keep the line's current qty */
    var line = ((lastCart && lastCart.items) || []).filter(function (it) { return it.key === key; })[0];
    var qty = line ? line.quantity : 1;
    root.classList.add("is-loading");
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty, selling_plan: sellingPlan }),
    })
      .then(function (r) { return r.json(); })
      .then(reconcileGifts)
      .then(renderWithPlans)
      .finally(function () { root.classList.remove("is-loading"); });
  }

  /* ---- recommendations: Shopify recommendations endpoint (Search & Discovery),
     related + complementary, combined across the whole cart. Theme-independent. ---- */
  var recsCache = {};
  function getRecs(pid) {
    if (recsCache[pid]) return Promise.resolve(recsCache[pid]);
    function api(intent) {
      return fetch("/recommendations/products.json?product_id=" + pid + "&intent=" + intent + "&limit=10", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          return ((d && d.products) || []).map(function (p) {
            return {
              id: p.id,
              variant: p.variants && p.variants[0] ? p.variants[0].id : "",
              title: p.title,
              price: p.price,
              image: p.featured_image || (p.images && p.images[0]) || "",
              available: p.available,
              source: intent,
            };
          });
        })
        .catch(function () { return []; });
    }
    return Promise.all([api("complementary"), api("related")]).then(function (res) {
      var combined = res[0].concat(res[1]);
      recsCache[pid] = combined;
      return combined;
    });
  }
  function renderRecs(cart) {
    var box = root.querySelector("[data-ncart-recs]");
    var list = root.querySelector("[data-ncart-recs-list]");
    if (!box || !list) return;
    if (!cart.items || !cart.items.length) { box.hidden = true; return; }
    var inCart = cart.items.map(function (i) { return i.product_id; });
    /* never offer the free-gift product as an upsell */
    var giftVariants = giftTiers().map(function (t) { return String(t.giftVariant); });
    var pids = [];
    cart.items.forEach(function (i) { if (pids.indexOf(i.product_id) === -1) pids.push(i.product_id); });
    Promise.all(pids.map(getRecs)).then(function (results) {
      var map = {};
      results.forEach(function (arr) {
        (arr || []).forEach(function (r) {
          if (!r || inCart.indexOf(r.id) !== -1) return;
          if (giftVariants.indexOf(String(r.variant)) !== -1) return;
          if (!map[r.id]) map[r.id] = { rec: r, score: 0, comp: false };
          map[r.id].score += 1;
          if (r.source === "complementary") map[r.id].comp = true;
        });
      });
      var ranked = Object.keys(map).map(function (k) { return map[k]; });
      ranked.sort(function (a, b) {
        if (a.comp !== b.comp) return a.comp ? -1 : 1;   // curated complementary first
        return b.score - a.score;                         // then most-recommended across the cart
      });
      var recs = ranked.slice(0, 4).map(function (x) { return x.rec; });
      if (!recs.length) { box.hidden = true; return; }
      box.hidden = false;
      list.innerHTML = recs
        .map(function (p) {
          var imgHtml = p.image ? '<img class="ncart__rec-img" src="' + thumb(p.image, 160) + '" alt="" loading="lazy">' : '<div class="ncart__rec-img"></div>';
          return (
            '<div class="ncart__rec">' + imgHtml +
            '<div class="ncart__rec-info"><div class="ncart__rec-name">' + p.title + "</div>" +
            '<div class="ncart__rec-price">' + money(p.price) + "</div></div>" +
            '<button class="ncart__rec-add" type="button" data-ncart-rec-add data-variant="' + (p.variant || "") + '"' + (p.available === false ? " disabled" : "") + ">Add</button>" +
            "</div>"
          );
        })
        .join("");
    });
  }

  function addVariant(id) {
    if (!id) return;
    root.classList.add("is-loading");
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(id), quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .finally(function () { root.classList.remove("is-loading"); });
  }

  /* ---- promo code: apply/remove via /cart/update.js (carries to checkout) ---- */
  function applyPromo() {
    var input = root.querySelector("[data-ncart-promo-input]");
    var msg = root.querySelector("[data-ncart-promo-msg]");
    if (!input) return;
    var code = (input.value || "").trim();
    if (!code) return;
    if (msg) msg.hidden = true;
    root.classList.add("is-loading");
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: code }),
    })
      .catch(function () {})
      .then(function () { return getCart(); })
      .then(reconcileGifts)
      .then(function (cart) {
        /* Did THIS code apply? Shopify reports each code with an "applicable" flag; a code
           that exists but doesn't qualify (min spend, wrong products, can't combine) comes
           back applicable:false; an unknown code is simply absent. Never infer from the cart's
           total discount — the free gift is itself a discount and would mask an invalid code. */
        var upper = code.toUpperCase();
        var entry = (cart.discount_codes || []).filter(function (d) {
          return String(d.code || "").toUpperCase() === upper;
        })[0];
        var applied = entry
          ? entry.applicable !== false
          : (cart.cart_level_discount_applications || []).some(function (a) {
              return a.type === "discount_code" && String(a.title || "").toUpperCase() === upper;
            });
        if (!applied) {
          /* don't leave a non-applicable code parked on the cart */
          if (entry && entry.applicable === false) {
            fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ discount: "" }),
            }).catch(function () {});
          }
          if (msg) {
            msg.className = "ncart__note ncart__note--warn";
            msg.textContent = "This code isn't valid or your bag doesn't qualify for it. Please check the code and try again.";
            msg.hidden = false;
          }
        } else {
          input.value = "";
        }
        return renderWithPlans(cart);
      })
      .finally(function () { root.classList.remove("is-loading"); });
  }

  function removePromo() {
    var msg = root.querySelector("[data-ncart-promo-msg]");
    if (msg) msg.hidden = true;
    root.classList.add("is-loading");
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ discount: "" }),
    })
      .catch(function () {})
      .then(function () { return getCart(); })
      .then(reconcileGifts)
      .then(renderWithPlans)
      .finally(function () { root.classList.remove("is-loading"); });
  }

  var lastCart = null;
  function render(cart) {
    lastCart = cart;
    stampRate(cart);
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="ncart__empty">Your cart is empty.</div>';
    } else {
      itemsEl.innerHTML = cart.items
        .map(function (it) {
          if (isGiftLine(it)) {
            var gsrc = it.image || (it.featured_image && it.featured_image.url) || "";
            var gimg = gsrc
              ? '<img class="ncart__item-img" src="' + thumb(gsrc, 240) + '" alt="" loading="lazy">'
              : '<div class="ncart__item-img"></div>';
            return (
              '<div class="ncart__item ncart__item--gift" data-key="' + it.key + '">' + gimg +
              '<div class="ncart__item-info">' +
              '<div class="ncart__item-top"><div class="ncart__item-name">' + it.product_title + "</div></div>" +
              '<span class="ncart__gift-pill">Free gift</span>' +
              '<div class="ncart__item-row"><span></span><div class="ncart__price">' +
              (it.original_line_price ? "<s>" + money(it.original_line_price) + "</s>" : "") + "FREE</div></div>" +
              "</div></div>"
            );
          }
          var src = it.image || (it.featured_image && it.featured_image.url) || "";
          var url = it.url || (it.handle ? "/products/" + it.handle : "");
          var imgInner = src
            ? '<img class="ncart__item-img" src="' + thumb(src, 240) + '" alt="" loading="lazy">'
            : '<div class="ncart__item-img"></div>';
          var img = url
            ? '<a class="ncart__item-img-link" href="' + url + '">' + imgInner + "</a>"
            : imgInner;
          var variant =
            it.variant_title && it.variant_title !== "Default Title"
              ? '<div class="ncart__item-variant">' + it.variant_title + "</div>"
              : "";

          var pc = planCache[it.handle] || { plans: [], requires: false };
          var eligible = pc.plans.length > 0;
          var subscribed = !!it.selling_plan_allocation;
          var currentPlanId = subscribed && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.id : null;
          var pct = eligible ? pc.plans[0].pct : 0;

          /* For a subscription line, Shopify's original_line_price is already the plan price,
             so the strike-through must come from the plan's compare-at (one-time) price. */
          var wasLine = 0;
          if (subscribed) {
            var spa = it.selling_plan_allocation || {};
            var compareUnit = spa.compare_at_price || (spa.per_delivery_price && spa.compare_at_price) || 0;
            if (compareUnit && compareUnit > (spa.price || it.price || 0)) wasLine = compareUnit * (it.quantity || 1);
          } else if (it.original_line_price && it.original_line_price > it.final_line_price) {
            wasLine = it.original_line_price; /* a sale-priced one-time item */
          }
          var priceHtml = wasLine
            ? '<span class="ncart__was">' + money(wasLine) + "</span>" + money(it.final_line_price)
            : money(it.final_line_price);

          var control = "";
          if (eligible && !subscribed && !pc.requires) {
            control = '<button class="ncart__sub-btn" type="button" data-ncart-sub>Upgrade to Subscription &amp; Save ' + pct + "%</button>";
          } else if (eligible && (subscribed || pc.requires)) {
            var opts = "";
            if (!pc.requires) opts += '<optgroup label="Pay full price"><option value="onetime">One-time only</option></optgroup>';
            opts += '<optgroup label="Subscribe &amp; save ' + pct + '%">' +
              pc.plans.map(function (p) { return '<option value="' + p.id + '"' + (p.id === currentPlanId ? " selected" : "") + ">" + p.name + "</option>"; }).join("") +
              "</optgroup>";
            control = '<select class="ncart__purchase-sel" data-ncart-plan>' + opts + "</select>";
          }

          return (
            '<div class="ncart__item" data-key="' + it.key + '" data-handle="' + (it.handle || "") + '">' +
            img +
            '<div class="ncart__item-info">' +
            '<div class="ncart__item-top">' +
            "<div>" +
            (url
              ? '<a class="ncart__item-name" href="' + url + '">' + it.product_title + "</a>"
              : '<div class="ncart__item-name">' + it.product_title + "</div>") +
            variant + "</div>" +
            '<button class="ncart__remove" type="button" data-ncart-remove aria-label="Remove item">' +
            '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>' +
            "</button>" +
            "</div>" +
            '<div class="ncart__item-row">' +
            '<div class="ncart__qty">' +
            '<button type="button" data-ncart-minus aria-label="Decrease">&minus;</button>' +
            '<input class="ncart__qty-input" type="text" inputmode="numeric" value="' + it.quantity + '" data-ncart-qty-input aria-label="Quantity">' +
            '<button type="button" data-ncart-plus aria-label="Increase">+</button>' +
            "</div>" +
            '<div class="ncart__price">' + priceHtml + "</div>" +
            "</div>" +
            control +
            "</div>" +
            "</div>"
          );
        })
        .join("");
    }
    /* subtotal shown without the gift line(s), since the gift is free */
    if (subtotalEl) {
      var giftSum = (cart.items || []).reduce(function (s, it) { return isGiftLine(it) ? s + it.final_line_price : s; }, 0);
      subtotalEl.textContent = money(Math.max(0, cart.total_price - giftSum));
    }
    /* Which code is on the cart. cart.discount_codes lists every code Shopify is holding,
       including ones that arrived via a link (/discount/CODE) and ones that save nothing
       yet (free-shipping codes, product codes whose products aren't in the bag). The
       cart-level application (when present) gives the amount the code is saving right now;
       cart.total_discount is NOT used because it includes the free gift's own discount. */
    var apps = cart.cart_level_discount_applications || [];
    var codeApp = null;
    for (var ai = 0; ai < apps.length; ai++) { if (apps[ai].type === "discount_code") { codeApp = apps[ai]; break; } }
    var codeName = appliedCode(cart);
    var codeAmt = 0;
    if (codeApp && codeName && String(codeApp.title || "").toUpperCase() === codeName) codeAmt = codeApp.total_allocated_amount || 0;
    if (!codeAmt && codeName) {
      /* product-class codes are allocated per line, not at cart level */
      (cart.items || []).forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) {
          if (a.discount_application && a.discount_application.type === "discount_code" &&
              String(a.discount_application.title || "").toUpperCase() === codeName) codeAmt += a.amount || 0;
        });
      });
    }

    var promoRow = root.querySelector("[data-ncart-promo]");
    var tagEl = root.querySelector("[data-ncart-discount-tag]");
    var sv = root.querySelector("[data-ncart-savings]");
    if (sv) sv.hidden = true; // amount now lives on the tag row
    if (codeName) {
      if (promoRow) promoRow.hidden = true;
      if (tagEl) {
        tagEl.hidden = false;
        tagEl.innerHTML =
          '<span class="ncart__tag"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>' +
          "<span>" + codeName + "</span>" +
          '<button type="button" data-ncart-promo-remove aria-label="Remove discount">&times;</button></span>' +
          '<span class="ncart__tag-amt">' + (codeAmt > 0 ? "-" + money(codeAmt) : "Applied at checkout") + "</span>";
      }
    } else {
      if (promoRow) promoRow.hidden = false;
      if (tagEl) { tagEl.hidden = true; tagEl.innerHTML = ""; }
    }
    renderRewards(cart);
    renderRecs(cart);
    /* let persona scripts (e.g. cust-persona-bamboo-gift.js) re-check the cart, as they did on Rebuy's event */
    try { document.dispatchEvent(new CustomEvent("rebuy:cart.change", { detail: { cart: cart } })); } catch (e) {}
  }

  function refresh() {
    root.classList.add("is-loading");
    return getCart()
      .then(reconcileGifts)
      .then(renderWithPlans)
      .finally(function () {
        root.classList.remove("is-loading");
      });
  }

  function changeQty(key, quantity) {
    root.classList.add("is-loading");
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(reconcileGifts)
      .then(renderWithPlans)
      .finally(function () {
        root.classList.remove("is-loading");
      });
  }

  /* ---- events inside the drawer ---- */
  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-ncart-close]")) {
      close();
      return;
    }
    var recAdd = e.target.closest("[data-ncart-rec-add]");
    if (recAdd) {
      addVariant(recAdd.getAttribute("data-variant"));
      return;
    }
    if (e.target.closest("[data-ncart-promo-remove]")) {
      removePromo();
      return;
    }
    var itemEl = e.target.closest(".ncart__item");
    if (itemEl) {
      var key = itemEl.getAttribute("data-key");
      var qtyEl = itemEl.querySelector("[data-ncart-qty-input]");
      var current = (qtyEl && parseInt(qtyEl.value, 10)) || 1;
      if (e.target.closest("[data-ncart-plus]")) changeQty(key, current + 1);
      else if (e.target.closest("[data-ncart-minus]")) changeQty(key, Math.max(0, current - 1));
      else if (e.target.closest("[data-ncart-remove]")) changeQty(key, 0);
      else if (e.target.closest("[data-ncart-sub]")) {
        var handle = itemEl.getAttribute("data-handle");
        var plans = (planCache[handle] || {}).plans || [];
        var pid = pickDefaultPlan(plans);
        if (pid) changePlan(key, pid);
      }
    }
  });

  /* ---- delivery dropdown: switch plan or revert to one-time ---- */
  root.addEventListener("change", function (e) {
    var sel = e.target.closest("[data-ncart-plan]");
    if (sel) {
      var planItem = e.target.closest(".ncart__item");
      if (!planItem) return;
      var planKey = planItem.getAttribute("data-key");
      var v = sel.value;
      changePlan(planKey, v === "onetime" ? null : Number(v));
      return;
    }
    /* typed quantity: commit on change/blur. Empty or invalid reverts; 0 removes. */
    var qtyInput = e.target.closest("[data-ncart-qty-input]");
    if (qtyInput) {
      var qtyItem = e.target.closest(".ncart__item");
      if (!qtyItem) return;
      var qtyKey = qtyItem.getAttribute("data-key");
      var n = parseInt(qtyInput.value, 10);
      if (isNaN(n) || n < 0) { refresh(); return; }
      changeQty(qtyKey, n);
    }
  });

  /* commit a typed quantity on Enter without waiting for blur */
  root.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    var qtyInput = e.target.closest("[data-ncart-qty-input]");
    if (qtyInput) { e.preventDefault(); qtyInput.blur(); }
  });

  if (checkoutBtn) checkoutBtn.addEventListener("click", function () { window.location.href = "/checkout"; });
  if (shopPayBtn) shopPayBtn.addEventListener("click", function () { window.location.href = "/checkout"; });

  var promoApplyBtn = root.querySelector("[data-ncart-promo-apply]");
  var promoInput = root.querySelector("[data-ncart-promo-input]");
  if (promoApplyBtn) promoApplyBtn.addEventListener("click", applyPromo);
  if (promoInput) promoInput.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); applyPromo(); } });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.getAttribute("aria-hidden") === "false") close();
  });

  /* ---- open from the header cart icon ---- */
  document.addEventListener("click", function (e) {
    var icon = e.target.closest("[data-js-cart-icon], a[href$='/cart'], a[href*='/cart?']");
    if (icon) {
      e.preventDefault();
      open();
    }
  });

  /* ---- intercept add-to-cart forms so the drawer opens on add ---- */
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
      e.preventDefault();
      root.classList.add("is-loading");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form),
      })
        .then(function (r) { return r.json(); })
        .then(function () { open(); })
        .catch(function () { form.submit(); });
    },
    true
  );

  /* Open on ANY successful add-to-cart request made by page scripts (quiz results,
     quick-add cards, older quiz, future pages) — the same behavior Rebuy provided by
     watching cart requests. Skipped for silent adds: the persona Bamboo Holder auto-add
     (_offer_gift) and our own gift line (_ncart_gift). */
  (function watchCartAdds() {
    if (!window.fetch || window.__ncartFetchPatched) return;
    window.__ncartFetchPatched = true;
    var origFetch = window.fetch;
    function isSilent(body) {
      try {
        if (!body) return false;
        if (typeof body === "string") return body.indexOf("_offer_gift") !== -1 || body.indexOf("_ncart_gift") !== -1;
        if (body instanceof FormData) {
          var silent = false;
          body.forEach(function (v, k) { if (/_offer_gift|_ncart_gift/.test(k)) silent = true; });
          return silent;
        }
      } catch (e) {}
      return false;
    }
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      var silent = isAdd && isSilent(init && init.body);
      var p = origFetch.apply(this, arguments);
      if (isAdd && !silent) {
        p.then(function (res) {
          if (res && res.ok) setTimeout(open, 150);
        }).catch(function () {});
      }
      return p;
    };
  })();

  /* open/refresh when the theme's existing add-to-cart flows fire their events
     (product page, bundle builder, quick-add all dispatch these) */
  ["cart:refresh", "rebuy:cart:refresh", "cart:added"].forEach(function (evt) {
    document.addEventListener(evt, function () { open(); });
  });
  document.addEventListener("cart:updated", function () {
    if (root.getAttribute("aria-hidden") === "false") refresh();
  });

  /* compatibility shim: existing code calls window.Rebuy.SmartCart.show() to open the cart.
     Point that at the native drawer so those calls keep working without editing product files. */
  if (!window.Rebuy) window.Rebuy = {};
  if (!window.Rebuy.SmartCart) window.Rebuy.SmartCart = {};
  window.Rebuy.SmartCart.show = open;
  window.Rebuy.SmartCart.hide = close;
  window.Rebuy.SmartCart.refresh = function () {
    if (root.getAttribute("aria-hidden") === "false") return refresh();
    return getCart().then(reconcileGifts);
  };

  /* expose a small API for other scripts / quick-add */
  window.NativeCart = { open: open, close: close, refresh: refresh };

  /* The full /cart page hands off here: it redirects to the previous page with #cart,
     and we open the drawer. The hash is removed so a reload does not reopen it. */
  if (window.location.hash === "#cart") {
    try { history.replaceState(null, "", window.location.pathname + window.location.search); } catch (e) {}
    setTimeout(open, 50);
  }
})();
